function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

/** Integer shares → English words (e.g. 10000 → Ten Thousand). */
export function sharesToEnglishWords(num: number): string {
  if (!Number.isFinite(num) || num < 0) return '';
  const n = Math.floor(num);
  if (n === 0) return 'Zero';
  const ones = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen',
  ];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  function chunk(v: number): string {
    if (v === 0) return '';
    if (v < 20) return ones[v];
    if (v < 100) return tens[Math.floor(v / 10)] + (v % 10 ? ` ${ones[v % 10]}` : '');
    return `${ones[Math.floor(v / 100)]} Hundred${v % 100 ? ` ${chunk(v % 100)}` : ''}`;
  }

  const parts: string[] = [];
  const billion = Math.floor(n / 1_000_000_000);
  const million = Math.floor((n % 1_000_000_000) / 1_000_000);
  const thousand = Math.floor((n % 1_000_000) / 1_000);
  const remainder = n % 1_000;
  if (billion) parts.push(`${chunk(billion)} Billion`);
  if (million) parts.push(`${chunk(million)} Million`);
  if (thousand) parts.push(`${chunk(thousand)} Thousand`);
  if (remainder) parts.push(chunk(remainder));
  return parts.join(' ').trim();
}

export function formatSharesNumeral(value: unknown): string {
  const n = Number(trim(value).replace(/,/g, ''));
  if (!Number.isFinite(n) || n < 0) return '';
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

export function syncSharesWordFields(model: {
  noOfShares: string;
  sharesNumeral: string;
  sharesWords: string;
}): void {
  const raw = trim(model.noOfShares).replace(/,/g, '');
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) {
    model.sharesNumeral = '';
    model.sharesWords = '';
    return;
  }
  model.sharesNumeral = formatSharesNumeral(n);
  model.sharesWords = sharesToEnglishWords(n);
}
